export default "__VITE_ASSET__jogFEBKD__"